import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { handleLoadingAndErrorState } from "#/redux/util/reduxUtils.js";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/rpe/naslov";

export const fetchAddresses = createAsyncThunk(
  "address/page",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        undefined,
        page,
        filter,
        sort
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const thunks = [fetchAddresses];

const addressSlice = createSlice({
  name: "address",
  initialState: {
    page: null,
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAddresses.fulfilled, (state, action) => {
      state.page = action.payload;
      state.isLoading = true;
    });

    handleLoadingAndErrorState(builder, thunks);
  },
});

export default addressSlice.reducer;
